import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';

// Google Analytics
var ReactGA = require('react-ga');
// Options available here - https://www.npmjs.com/package/react-ga
ReactGA.initialize('UA-39143914-7'); // TODO - Pull this into an env config

// Common components
import Header from './components/shared/Header';
import ScrollToTop from './components/shared/ScrollToTop';

// Containers
import Api from './components/Api';
import WidgetsContainer from './components/widgets/containers/WidgetsContainer';
import SearchResultsContainer from './components/search/containers/SearchResultContainer';

// Static Components
import Home from './components/Home';
import GettingStarted from './components/GettingStarted';
import JavascriptSdk from './components/JavaScriptSdk';
import NotFound from './components/NotFound';
import Changelog from './components/Changelog';

// CSS
import './css/style.less';

// Import react router dependencies
import { Route, Switch } from 'react-router';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import store, { history } from './store';

// Listen to history changes for analytics
history.listen((location, action) => {
	const { pathname, hash } = location;
	// Google Analytics
	ReactGA.set({ pathname, hash });
	ReactGA.pageview(pathname);
});

const router = (
	<Provider store={store}>
		<ConnectedRouter history={history}>
			<div className="app">
				<Header />
				<SearchResultsContainer />
				<ScrollToTop scrollElId="content">
					<Switch>
						<Route exact path='/' component={Home} ></Route>
						<Route path="/getting-started" component={GettingStarted} ></Route>
						<Route exact path="/api/responses/:response" component={Api} ></Route>
						<Route exact path="/api/:category?" component={Api} ></Route>
						<Route path="/javascript-sdk" component={JavascriptSdk} ></Route>
						<Route path="/widgets/:category?/:widget?" component={WidgetsContainer} ></Route>
						<Route path="/changelog" component={Changelog} ></Route>
						<Route component={NotFound}></Route>
					</Switch>
				</ScrollToTop>
			</div>
		</ConnectedRouter>
	</Provider>
);

render(router, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js